'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { MyNumberCollectionPage } from '../-components/MyNumberCollectionPage';
export const Route = createFileRoute('/_staff/labor-core/_egov-mock/egov-onboarding/my-number-collection/')({
  component: MyNumberCollectionPage
});